module.exports = __webpack_public_path__ + "static/media/carta_28.f6c06713.jpg";